'use client';
import { Button } from '@heroui/button';
import { useState } from 'react';
import LeaveMessage from '@/components/LeaveMessage';

export default function Index() {
  const [visible, setVisible] = useState<boolean>(false);

  function onClose() {
    setVisible(false);
  }
  return (
    <div>
      <div className="flex bg-white dark:bg-[#171717] pt-[10px] pr-[15px] pb-[7px] pl-[15px]">
        <Button
          style={{ backgroundImage: 'linear-gradient(90deg, #FFAE01 0%, #FF921C 100%)' }}
          onPress={() => setVisible(true)}
          color='warning'
          className="bg-gradient-to-tr from-[#FFAE01] to-[#FF921C] text-white shadow-lg grow rounded-[4px] h-[44px] text-[16px]"
        >
          获取底价
        </Button>
      </div>
      <LeaveMessage open={visible} onClose={onClose} />
    </div>
  );
}
